<i18n>
{
  "ru": {
    "access_date": "Дата доступа",
    "remove_user": "Удалить пользователя"
  },
  "en": {
    "access_date": "Access date",
    "remove_user": "Remove user"
  }
}
</i18n>
<template>
  <div>
    <user-modal
      v-if="showUserModal"
      :url="userUrl"
      :callback="userAdded"
      :visible.sync="showUserModal"
    />

    <el-row class="right-align" :gutter="20">
      <el-col>
        <el-button
          v-if="canRemoveUser"
          :disabled="!selectedUser"
          round
          type="danger"
          @click="removeUser"
          >{{ $t("remove_user") }}</el-button
        >
        <el-button
          v-if="canAddUser"
          :disabled="!canEditUser"
          round
          type="primary"
          @click="editUser"
          >{{ $t("edit_user") }}</el-button
        >
        <el-button v-if="canAddUser" round type="primary" @click="addUser">{{
          $t("add_user")
        }}</el-button>
      </el-col>
    </el-row>
    <el-card>
      <el-form @submit.native.prevent="loadUsers">
        <el-row :gutter="20" class="users-setings-header">
          <el-col :sm="4">
            <h4>{{ $t("filter") }}:</h4>
          </el-col>
          <el-col :sm="5">
            <el-input v-model="filter.search_form_first_name" :placeholder="$t('firstname')" />
          </el-col>
          <el-col :sm="5">
            <el-input v-model="filter.search_form_last_name" :placeholder="$t('lastname')" />
          </el-col>
          <el-col :sm="5">
            <el-input v-model="filter.search_form_email" placeholder="E-mail" />
          </el-col>
          <el-col :sm="5">
            <el-input
              v-model="filter.search_form_username"
              :placeholder="$t('username')"
            />
          </el-col>
          <el-col :sm="{span: 5, offset: 10}">
            <el-select
              v-model="filter.search_form_status"
              :placeholder="$t('active')"
              clearable
            >
              <el-option :label="$t('yes')" value="1"></el-option>
              <el-option :label="$t('no')" value="0"></el-option>
            </el-select>
          </el-col>
          <el-col :sm="5" class="aligner right">
            <el-button native-type="submit" round type="primary">{{
              $t("search")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-table
          :data="tableData"
          @row-click="showUser"
          v-loading="loading"
          style="width: 100%"
          highlight-current-row
          @current-change="handleSelectionChange"
        >
        <el-table-column prop="id" width="160" label="Id">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.id }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="username" width="160" :label="`${$t('firstname')}, ${$t('lastname')}`">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.first_name }} {{scope.row.last_name }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="username" width="160" :label="$t('username')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.username }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="email" label="E-mail">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.email }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="date_orig" :label="$t('date_orig')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.date_orig }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="date_last" :label="$t('access_date')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.date_last }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('active')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
                >{{ scope.row.status === "1" ? $t("yes") : $t("no") }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="aligner right"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
          @current-change="changePage"
        ></el-pagination>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import UserModal from './UserModal'

export default {
  name: 'users',
  components: {
    'user-modal': UserModal
  },
  data: () => ({
    showUserModal: false,
    canAddUser: false,
    canRemoveUser: false,
    userUrl: null,
    filter: {
      search_form_id: '',
      search_field_type_id: 'direct',
      search_form_distinct_id: '',
      search_form_date_orig_date_from: '',
      search_form_date_orig_date_to: '',
      search_form_username: '',
      search_form_status: '',
      search_form_first_name: '',
      search_form_last_name: '',
      search_form_email: '',
      search_form_company: '',
      search_form_address1: '',
      search_form_city: '',
      search_form_state: '',
      search_form_zip: '',
      search_form_country_id: '',
      search_field_type_country_id: 'direct',
      search_form_phone: '',
      search_form_fax: '',
      submit: 'Поиск',

      order_field: '',
      order_type: ''
    },

    pagination: {
      total: 0,
      pageSize: 25,
      currentPage: 0
    },

    pageLinks: {},
    sortLinks: {},
    tableData: [],
    selectedUser: null,
    loading: true,
    redirectUrl: ''
  }),
  computed: {
    canEditUser () {
      return this.selectedUser && this.selectedUser.edit_url
    }
  },
  created () {
    this.loadUsers()
  },
  methods: {
    processResponse (vars) {
      if (vars) {
        vars.res.records.forEach(r => {
          if (r.date_last) {
            r.date_last = new Date(parseInt(r.date_last) * 1000).toLocaleString(this.$localeForDate)
          }
          if (r.date_orig) {
            r.date_orig = new Date(parseInt(r.date_orig) * 1000).toLocaleString(this.$localeForDate)
          }
          r.show = false
        })
        this.tableData = vars.res.records
        this.pagination = {
          total: parseInt(vars.res.results),
          currentPage: parseInt(vars.res.cpage),
          pageSize: parseInt(vars.res.limit)
        }

        if (!this.pageLinks) this.pageLinks = {}
        if (vars.paginator) {
          if (vars.paginator.end_pages) {
            Object.keys(vars.paginator.end_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.end_pages[k]
            })
          }
          if (vars.paginator.pre_pages) {
            Object.keys(vars.paginator.pre_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.pre_pages[k]
            })
          }
          if (vars.paginator.next_pages) {
            Object.keys(vars.paginator.next_pages).forEach(k => {
              this.pageLinks[k] = vars.paginator.next_pages[k]
            })
          }
        }

        this.filter.order_field = vars.res.order
        this.filter.order_type = vars.res.sort
        this.sortLinks = vars.account_data
      } else {
        this.tableData = []
        this.pagination = {}
      }
    },
    parseUsers (promise) {
      this.loading = true
      this.tableData = []
      promise.then((data) => {
        this.processResponse(data.page_vars)
        this.canAddUser = apiRes.addUserUrl && data.page_vars.show_adduser
        this.canRemoveUser = data.page_vars.show_deluser
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    loadUsers () {
      this.loading = true
      apiRes.post(apiRes.usersUrl, this.filter, true).then((url) => {
        this.redirectUrl = url
        this.parseUsers(apiRes.get(this.redirectUrl))
      })
    },
    changePage (newPage) {
      if (this.pageLinks[newPage]) {
        this.parseUsers(apiRes.get(this.pageLinks[newPage]))
      }
    },
    changeSort (sort) {
      this.filter.order_field = sort.prop
      this.filter.order_type = sort.order === 'ascending' ? 'asc' : 'desc'
      this.loadUsers()

      // if (this.sortLinks[this.filter.order_field]) {
      //   this.parseUsers(apiRes.get(this.sortLinks[name]))
      // }
    },
    showUser (user) {
      // this.userDetails = user
      // this.showUserModal = true
    },
    handleSelectionChange (val) {
      this.selectedUser = val
    },
    addUser () {
      this.userUrl = apiRes.addUserUrl
      this.showUserModal = true
    },
    userAdded (users) {
      this.processResponse(users)
    },
    editUser () {
      this.userUrl = this.selectedUser.edit_url
      this.showUserModal = true
    },
    removeUser () {
      if (this.selectedUser && this.redirectUrl) {
        this.$confirm(this.$t('alert_delete')).then(() => {
          this.loading = true
          apiRes.post(this.redirectUrl, {
            l: [this.selectedUser.id],
            acv: '',
            page: this.pageLinks[this.pagination.currentPage],
            a2: 'Удалить'
          }).then((res) => {
            if (res.page_vars) {
              this.loadUsers()
            }
          }).catch(() => {
            this.loading = false
          })
        }).catch(() => { })
      }
    }
  }
}
</script>
